<template>
    <div>
        
    </div>
</template>

<script>
export default {
    created(){
        localStorage.removeItem( 'role' );
        localStorage.removeItem( 'token' );
        localStorage.removeItem( 'session' );
        localStorage.removeItem( 'user' );
        this.$router.push( '/' );
    }
}
</script>